import { render, staticRenderFns } from "./RelatedJobDialog.vue?vue&type=template&id=383e2463&"
import script from "./RelatedJobDialog.vue?vue&type=script&lang=js&"
export * from "./RelatedJobDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports